import {Grid, Typography} from "@mui/material";
import {formatoFecha} from "../../Utilidades/formatoFecha";
import {formatoMoneda} from "../../Utilidades/formatoMoneda";

export const Tarjeta_Abono = ({item}) => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{borderBottom: 1, py: 1}}
        >


            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Typography sx={{fontSize: 12}}>{formatoFecha(item.fecha)}</Typography>
            </Grid>

            <Grid container size={8}>
                <Typography sx={{fontWeight: 800}} >{formatoMoneda(item.valor)}</Typography>
            </Grid>

            <Grid container size={4} sx={{justifyContent: 'flex-end'}} >
                <Typography sx={{fontWeight: 400}} >{item.metodo}</Typography>
            </Grid>


        </Grid>
    )
}